import { ReactNode } from "react";

type TransProps = {
  children?: ReactNode;
};

export function Trans({ children }: Readonly<TransProps>) {
  return <>{children}</>;
}
